module.exports = __webpack_public_path__ + "img/7.f4a5c14b.png";